import { render } from "./LoyverseSettings.vue?vue&type=template&id=2b266c8c&scoped=true"
import script from "./LoyverseSettings.vue?vue&type=script&lang=js"
export * from "./LoyverseSettings.vue?vue&type=script&lang=js"

import "./LoyverseSettings.vue?vue&type=style&index=0&id=2b266c8c&scoped=true&lang=css"
import "./LoyverseSettings.vue?vue&type=style&index=1&id=2b266c8c&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b266c8c"]])

export default __exports__